import { motion } from "framer-motion";
import { ArrowRight, Zap, MousePointerClick, Users } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background effects */}
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full" style={{ background: "var(--gradient-glow)" }} />
      <div className="absolute top-20 right-20 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-secondary/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 text-sm text-muted-foreground mb-8"
          >
            <Zap className="w-4 h-4 text-secondary" />
            <span>Entrega rápida em até 72 horas</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-balance"
          >
            Seu site pronto para{" "}
            <span className="gradient-text">
              gerar
              <br className="hidden md:block" />
              clientes
            </span>{" "}
            em até 72 horas.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 text-balance"
          >
            Landing pages e sites profissionais criados para empresas que querem anunciar, captar contatos e vender mais pela internet.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <a
              id="btn-cta-hero"
              href="#planos"
              className="group flex items-center gap-2 rounded-xl bg-primary px-8 py-4 text-base font-semibold text-primary-foreground transition-all hover:opacity-90 glow-blue"
            >
              Criar minha página agora
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#planos"
              className="flex items-center gap-2 rounded-xl glass px-8 py-4 text-base font-semibold text-foreground transition-all hover:bg-muted"
            >
              Ver planos
            </a>
          </motion.div>

          <motion.ul
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-8 text-sm text-muted-foreground"
          >
            {[
              "Ideal para anúncios no Google e Instagram",
              "Páginas rápidas e focadas em conversão",
              "Atendimento humano com especialistas",
            ].map((text, i) => (
              <li key={i} className="flex items-center gap-2">
                <span className="text-secondary">✔</span>
                <span>{text}</span>
              </li>
            ))}
          </motion.ul>

          {/* Animated flow */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="mt-20 flex flex-wrap items-center justify-center gap-4 md:gap-6"
          >
            {[
              { icon: MousePointerClick, label: "Clique no anúncio", color: "text-primary" },
              { icon: () => <span className="text-2xl">→</span>, label: "", color: "text-muted-foreground" },
              { icon: Zap, label: "Landing Page", color: "text-secondary" },
              { icon: () => <span className="text-2xl">→</span>, label: "", color: "text-muted-foreground" },
              { icon: Users, label: "Novo cliente", color: "text-primary" },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.2 + i * 0.15 }}
                className={`flex items-center gap-2 ${item.label ? "glass-card rounded-xl px-5 py-3" : ""}`}
              >
                <item.icon className={`w-5 h-5 ${item.color}`} />
                {item.label && <span className="text-sm font-medium">{item.label}</span>}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
